import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { replaceVariables } from "utils";
import SMSChatBubble from "./SMSChatBubble";
import "../../styles/marketing-dashboard.css";

const SMSChatBubblePreview = () => {
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const batchData = useSelector((state) => state.communicationBatching);
  const {
    textContent: message,
    batchName,
    fileSamples,
    textContentVariables,
  } = batchData;

  const emailList = fileSamples.map((obj) => obj.email);
  const [sampleDataIdx, setSampleDataIdx] = useState(0);

  const updateSample = () => {
    setSampleDataIdx((sampleDataIdx + 1) % emailList.length);
  };

  useEffect(() => {}, [message]);
  return (
    <div className="flex flex-col justify-center mx-auto">
      {editMode ? (
        <>
          {error && (
            <div className="text-red-500 text-center mx-auto">
              <small>{error}</small>
            </div>
          )}
          <SMSChatBubble setError={setError} enabled={editMode} />
        </>
      ) : (
        <>
          <span className="mx-auto text-center text-gray-600">
            {batchName ? (
              <span>{`batch name : ${batchName}`}</span>
            ) : (
              <small className="text-gray-600">
                <span className="text-red-500">error: </span>
                  no batch name found
              </small>
            )}
          </span>
          {emailList && emailList.length ? (
            <div className="flex flex-row justify-center mx-auto my-5">
              <div>
                <div className="flex justify-center chat-bubble mx-auto my-auto">
                  <textarea
                    name="chat-bubble-preview"
                    className="chat-bubble mt-2"
                    cols="70"
                    rows="6"
                    disabled
                    placeholder="Welcome to TomoCredit..."
                    value={
                      emailList && message
                        ? replaceVariables(message, textContentVariables, fileSamples[sampleDataIdx])
                        : ""
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <small className="text-gray-600">
              <span className="text-red-500">error: </span>
                no csv file uploaded
            </small>
          )}
        </>
      )}
      <span className="mx-auto text-center py-3">
        <button
          type="button"
          className="focus:outline-none focus:border-none active:outline-none active:border-none"
          onClick={() => setEditMode(!editMode)}
        >
          <small className={editMode ? "text-red-500" : "text-green-500"}>
            {editMode ? "preview" : "edit"}
            <i className="fas fa-edit mx-1" />
          </small>
        </button>
        <button
          type="button"
          className="focus:outline-none focus:border-none active:outline-none active:border-none"
          onClick={() => updateSample() }
        >
          <small className="text-green-500">
            Randomize Sample
            <i className="fas fa-edit mx-1" />
          </small>
        </button>
      </span>
    </div>
  );
};

export default SMSChatBubblePreview;
